import { render } from "./doctor-list.vue?vue&type=template&id=1df295ba&scoped=true"
import script from "./doctor-list.vue?vue&type=script&lang=js"
export * from "./doctor-list.vue?vue&type=script&lang=js"

import "./doctor-list.vue?vue&type=style&index=0&id=1df295ba&scoped=true&lang=css"

import exportComponent from "/studio/gordon/Studio/mylink-intgr/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1df295ba"]])

export default __exports__